import { apiPost } from '@/shared/utils/requestBuilder';
import type { CadastrarAdvogadoAvulsoDto } from '@/types/advogado/advogadoAvulsoTypes';

export const advogadoAvulsoService = {
  cadastrar: async (data: CadastrarAdvogadoAvulsoDto): Promise<void> => {
    const response = await apiPost('/advogados/avulso', data, true);
    if (!response.ok) {
      const errorData = await response
        .json()
        .catch(() => ({ error: 'Erro ao cadastrar advogado' }));
      throw new Error(errorData.error || 'Erro ao cadastrar advogado');
    }
  },
};
